import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import axiosInstance from './axiosInstance';
import RingLoader from './Loader/RingLoader';
import { useAuth } from '../../context/AuthContext';
import { CABINET_PATH } from '../../msg/inviteLink';

// WEB-2: роль-гейт маршрута. UX, не защита (сервер авторизует по БД —
// см. AuthContext). Пока роль не подтверждена — лоадер (не мигать редиректом);
// роль не совпала -> на /settings/profile (доступен любому залогиненному).
export const RequireRole = ({ role }) => {
  const { role: currentRole, loaded } = useAuth();
  if (!loaded) return <RingLoader />;
  if (currentRole !== role) return <Navigate to="/settings/profile" replace />;
  return <Outlet />;
};

const PrivateRoutes = () => {
  const [auth, setAuth] = useState(null);

  useEffect(() => {
    let isMounted = true;

    axiosInstance
      .get('website/buildings')
      .then(() => {
        if (isMounted) setAuth(true);
      })
      .catch(() => {
        if (isMounted) setAuth(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (auth === null) return <RingLoader />;
  // 🔴 С ключом кабинета: в браузере, где есть ещё и сессия участника, голый
  // корень увёл бы вышедшего владельца в чужую переписку вместо формы входа
  // (ревью WEB-28).
  if (auth === false) return <Navigate to={CABINET_PATH} />;

  return <Outlet />; 
};

export default PrivateRoutes;
